/* ═══════════════════════════════════════════════
   LUMIÈRE — lumiere.js  v2
═══════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ─────────────────────────────────────────────
     CART DRAWER
  ───────────────────────────────────────────── */
  const drawer     = document.getElementById('cart-drawer');
  const drawerBody = document.getElementById('cart-drawer-body');
  const drawerFoot = document.getElementById('cart-drawer-footer');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    renderDrawer();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  }

  // All cart triggers → open drawer
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-trigger]')) {
      e.preventDefault();
      openDrawer();
    }
    if (e.target.closest('[data-cart-close]')) {
      closeDrawer();
    }
  });

  // Esc to close
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  async function renderDrawer() {
    if (!drawerBody) return;
    drawerBody.innerHTML = '<div class="cart-drawer__loading">Loading…</div>';
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      updateAllCounts(cart.item_count);

      if (!cart.items.length) {
        drawerBody.innerHTML = '<div class="cart-drawer__empty"><p>Your bag is empty.</p><a href="/collections/all" class="btn-primary" style="font-size:9px;padding:14px 32px">Shop Now</a></div>';
        drawerFoot.innerHTML = '';
        return;
      }

      drawerBody.innerHTML = cart.items.map(item => `
        <div class="cdi" data-key="${item.key}">
          <a href="${item.url}" class="cdi__img">
            <img src="${item.image ? item.image : ''}" alt="${escHtml(item.product_title)}" loading="lazy">
          </a>
          <div class="cdi__info">
            <a href="${item.url}" class="cdi__name">${escHtml(item.product_title)}</a>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<span class="cdi__variant">${escHtml(item.variant_title)}</span>` : ''}
            <div class="cdi__row">
              <div class="cdi__qty">
                <button class="cdi__minus" data-key="${item.key}" data-qty="${item.quantity - 1}" aria-label="Decrease">−</button>
                <span>${item.quantity}</span>
                <button class="cdi__plus" data-key="${item.key}" data-qty="${item.quantity + 1}" aria-label="Increase">+</button>
              </div>
              <span class="cdi__price">${fmtMoney(item.final_line_price)}</span>
            </div>
            <button class="cdi__remove" data-key="${item.key}" data-qty="0">Remove</button>
          </div>
        </div>
      `).join('');

      const free    = 200000; // ₹2000 in paise — adjust as needed
      const total   = cart.total_price;
      const remain  = free - total;
      const pct     = Math.min(100, Math.round((total / free) * 100));
      const freeMsg = remain > 0
        ? `Add ${fmtMoney(remain)} more for free shipping`
        : '✓ You\'ve unlocked free shipping!';

      drawerFoot.innerHTML = `
        <div class="cdf__ship">
          <span>${freeMsg}</span>
          <div class="cdf__bar"><div class="cdf__fill" style="width:${pct}%"></div></div>
        </div>
        <div class="cdf__total">
          <span>Subtotal</span>
          <span>${fmtMoney(total)}</span>
        </div>
        <p class="cdf__note">Taxes & shipping calculated at checkout.</p>
        <a href="/checkout" class="btn-primary cdf__checkout">Checkout</a>
        <a href="/cart" class="cdf__view">View full cart</a>
      `;
    } catch (err) {
      drawerBody.innerHTML = '<div class="cart-drawer__empty"><p>Could not load cart.</p></div>';
    }
  }

  // Qty change / remove
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-key][data-qty]');
    if (!btn) return;
    const key = btn.dataset.key;
    const qty = parseInt(btn.dataset.qty, 10);
    btn.disabled = true;
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      renderDrawer();
    } catch (_) { btn.disabled = false; }
  });

  /* ─────────────────────────────────────────────
     QUICK ADD TO CART
  ───────────────────────────────────────────── */
  document.querySelectorAll('.product-quick-add[data-variant-id]').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault(); e.stopPropagation();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.textContent = 'Adding…'; btn.disabled = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (res.ok) {
          btn.textContent = '✓ Added';
          updateAllCounts();
          openDrawer();
          setTimeout(() => { btn.textContent = '+ Add to Bag'; btn.disabled = false; }, 2000);
        } else {
          btn.textContent = 'Sold Out';
          setTimeout(() => { btn.textContent = '+ Add to Bag'; btn.disabled = false; }, 2000);
        }
      } catch (_) { btn.textContent = '+ Add to Bag'; btn.disabled = false; }
    });
  });

  /* ─────────────────────────────────────────────
     COUNT HELPERS
  ───────────────────────────────────────────── */
  async function updateAllCounts(count) {
    if (count === undefined) {
      try { const r = await fetch('/cart.js'); const c = await r.json(); count = c.item_count; } catch (_) { return; }
    }
    document.querySelectorAll('#fab-count, #header-cart-count').forEach(el => {
      el.textContent = count;
      if (el.id === 'fab-count') el.style.display = count > 0 ? 'flex' : 'none';
    });
    const headerBtn = document.getElementById('header-cart-btn');
    if (headerBtn) headerBtn.setAttribute('aria-label', `Cart (${count} items)`);
  }

  /* ─────────────────────────────────────────────
     MOBILE NAVIGATION
  ───────────────────────────────────────────── */
  const mobileOverlay = document.getElementById('mobile-nav-overlay');

  function openMobileNav() {
    if (!mobileOverlay) return;
    mobileOverlay.classList.add('is-open');
    mobileOverlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('nav-open');
    const btn = document.getElementById('mobile-menu-btn');
    if (btn) btn.setAttribute('aria-expanded', 'true');
  }

  function closeMobileNav() {
    if (!mobileOverlay) return;
    mobileOverlay.classList.remove('is-open');
    mobileOverlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('nav-open');
    const btn = document.getElementById('mobile-menu-btn');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mobile-nav-open]')) openMobileNav();
    if (e.target.closest('[data-mobile-nav-close]')) closeMobileNav();
  });

  /* ─────────────────────────────────────────────
     STICKY HEADER
  ───────────────────────────────────────────── */
  const header = document.getElementById('site-header');
  if (header) {
    let lastScroll = 0;
    header.style.transition = 'transform 0.35s ease';
    window.addEventListener('scroll', () => {
      const cur = window.scrollY;
      header.style.transform = (cur > lastScroll && cur > 120) ? 'translateY(-100%)' : 'translateY(0)';
      lastScroll = cur;
    }, { passive: true });
  }

  /* ─────────────────────────────────────────────
     COUNTDOWN TIMER
  ───────────────────────────────────────────── */
  document.querySelectorAll('[data-countdown]').forEach(el => {
    const end  = new Date(el.dataset.countdown).getTime();
    const tick = () => {
      const now  = Date.now();
      const diff = Math.max(0, end - now);
      const h    = Math.floor(diff / 3600000);
      const m    = Math.floor((diff % 3600000) / 60000);
      const s    = Math.floor((diff % 60000) / 1000);
      const pad  = n => String(n).padStart(2, '0');
      const dEl  = el.closest('[data-countdown-wrap]');
      if (dEl) {
        const parts = dEl.querySelectorAll('[data-cd-h],[data-cd-m],[data-cd-s]');
        parts.forEach(p => {
          if (p.dataset.cdH !== undefined) p.textContent = pad(h);
          if (p.dataset.cdM !== undefined) p.textContent = pad(m);
          if (p.dataset.cdS !== undefined) p.textContent = pad(s);
        });
      }
      if (diff > 0) requestAnimationFrame(tick);
    };
    tick();
  });

  /* ─────────────────────────────────────────────
     HELPERS
  ───────────────────────────────────────────── */
  function fmtMoney(cents) {
    return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
  }

  function escHtml(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

})();
